import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material"
import { Box, IconButton, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { getChildrenByType } from "lib/react-utils"
import React, { useRef } from "react"

const useStyles = makeStyles()({
  mainContainer: {
    overflow: "hidden",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 10,
  },
  headingContainer: {
    display: "flex",
    alignItems: "center",

    marginRight: 40,
  },
  controllersContainer: {
    display: "inline-flex",
    alignSelf: "flex-end",

    paddingBottom: 8,
  },
  contentContainer: {
    display: "flex",

    overflowX: "scroll",
    overflowY: "hidden",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
})

const Heading = (props: { children: React.ReactElement<typeof Typography> }) => (
  <>{props.children}</>
)
const Content = (props: { children: React.ReactNode }) => <>{props.children}</>

// SCROLLER
export interface ScrollerProps {
  children: [React.ReactElement<typeof Heading>, React.ReactElement<typeof Content>]
  scrollOffset?: number
}

export const Scroller = (props: ScrollerProps) => {
  const { children, scrollOffset } = props
  const { classes } = useStyles()
  const contentContainerRef = useRef<HTMLDivElement>(null)
  const heading = getChildrenByType(children, Heading)
  const content = getChildrenByType(children, Content)

  const getScrollOffset = () => {
    if (scrollOffset) return scrollOffset
    if (contentContainerRef.current) {
      // 75% of container width
      return (contentContainerRef.current.clientWidth * 75) / 100
    }
    return 250
  }
  const scrollLeft = () =>
    contentContainerRef.current?.scroll({
      left: contentContainerRef.current.scrollLeft - getScrollOffset(),
      behavior: "smooth",
    })

  const scrollRight = () =>
    contentContainerRef.current?.scroll({
      left: contentContainerRef.current.scrollLeft + getScrollOffset(),
      behavior: "smooth",
    })

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.headerContainer}>
        <Box className={classes.headingContainer}>{heading}</Box>
        <Box className={classes.controllersContainer}>
          <IconButton aria-label="Scroll left" onClick={scrollLeft}>
            <KeyboardArrowLeft />
          </IconButton>
          <IconButton aria-label="Scroll right" onClick={scrollRight}>
            <KeyboardArrowRight />
          </IconButton>
        </Box>
      </Box>

      <Box ref={contentContainerRef} className={classes.contentContainer}>
        {content}
      </Box>
    </Box>
  )
}

export const HorizontalScroll = {
  Scroller,
  Heading,
  Content,
}
